module.exports = __webpack_public_path__ + "js/0.a8206cec.worker.js"